<template>
    <div class="contents lang">
        <zh_DoctorCard :doctorList="doctorList"/>
    </div>
</template>

<script>
export default{
    data(){
        return {
            doctorList: [],
        }
    },
    methods: {
        getDoctorList(){
            const param = {
                startIndex: 1,
                pageRow: 999,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                deptCd: 'HIMG',
                orderType: 'deptSort',
                // deptType: 1
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                const cnt = res.data.doctorTotCnt
                if(cnt > 0){
                    this.doctorList = res.data.doctorList
                }
            })
        },
        getHealthDoctorList(){
            const param = {
                langCd: this.$store.getters.getLang
            }
            this.axios.get(this.api.glb.health, {params: param})
            .then(res => {
            })
        },
    },
    mounted() {
        this.getDoctorList()
        //this.getHealthDoctorList()
    },
}
</script>
